const PinterestProductCard = (productID: number, productName: string, productPrice: string) => {
  if (window?.pintrk && typeof window?.pintrk === 'function') {
    window.pintrk('track', 'viewProduct', {
      product_name: productID,
      product_id: productName,
      product_price: productPrice
    });
  }
};
export default PinterestProductCard;